import CustomRoleListPage from "./custom-role-list-page.jsx";

export default CustomRoleListPage;